<template>
	<div class="notification content">
		<component :is="href('/interactions/notification/details').content" />
		<form ref="form" v-show="showForm" v-on:submit.prevent="sendMail">
			<label><font-awesome-icon icon="mobile-alt"/> {{ href('/interactions/notification/details').meta.mobile }}</label>
			<input type="phone" name="phone" v-model="phone">
			<input type="hidden" name="subject" :value="href('/interactions/notification/details').meta.subject">
			<input type="hidden" name="context" value="demo-notification">
			<input type="hidden" name="country" :value="country">
			<input type="hidden" name="language" :value="lang">
			<button type="submit">{{ href('/interactions/notification/details').meta.send }}</button>
			<auto-action v-if="auto" :message="href('/interactions/notification/details').meta.countdown" :cancel="href('/interactions/notification/details').meta.cancel" @action="send"/>
		</form>
		<div class="form" v-show="!showForm">
			<label><font-awesome-icon icon="mobile-alt"/> {{ href('/interactions/notification/details').meta.mobile }}</label>
			<div class="input">{{ phone }}</div>
		</div>
	</div>
</template>

<script>
import hreflang from '@/lib/hreflang'
import { mapState } from 'vuex'

import AutoAction from '../AutoAction.vue'

export default {
	name: 'NotificationInteraction',
	mixins: [ hreflang ],
	components: {
		AutoAction
	},
	data() {
		return {
			sending: false,
			phone: '',
			country: '',
			identity: false
		}
	},
	props: {
		showDetails: Boolean,
	},
	watch: {
		passport() {
			return this.initPassport()
		}
	},
	computed: {
		...mapState({
			passport: state => state.demo.passport,
			lang: state => state.settings.lang,
			events: state => state.demo.interactions.notification.events,
		}),
		showForm() {
			return !this.sending && this.showDetails
		},
		auto() {
			return this.identity && !this.events.length
		}
	},
	methods: {
		initPassport() {
			if (!this.phone) {
				if (this.passport && this.passport.identities) {
					let identity = this.passport.identities.find(identity => identity.name == 'e164')
					if (identity) {
						this.phone = identity.value
						this.identity = true
					} else {
						identity = this.passport.identities.find(identity => identity.id == 'phone')
						if (identity) {
							this.phone = identity.value
							this.identity = true
						}
					}
				}
			}
		},
		sendMail() {
			window.whitebox.init('mail', mail => {
				if (mail) {
					mail.service.apply(this.$refs.form)
					this.sending = true
				}
			})
		}
	},
	created() {
		this.document(require('documents/en/interactions/notification-details.md'), 'en')
	},
	mounted() {
		this.initPassport()

		window.whitebox.init('analytics', analytics => {
			if (analytics && 
				window.whitebox.services.analytics.location && 
				window.whitebox.services.analytics.location.country
			) {
				this.country = window.whitebox.services.analytics.location.country.toLowerCase()
			}
		})
	}
}
</script>

<style scoped lang="less">
@import url('~whitebox-presentation/src/assets/variables.less');
@import url('~whitebox-presentation/src/assets/mixins.less');

form,
.form {
	margin-top: @gap * 2;
}
input,
.input {
	width: 60%;
	margin-right: @gap * 4;
}
button {
	transform: translateY(-@gap);
}
input, button {
	display: inline-block;
}
.content {
	padding: 0;
}

</style>
